import { useEffect } from "react";
import { ApiQueries, DaymapIcon, DaymapIconType, useSettings } from 'daymap-react';
import { useState } from 'react';
import { DaymapDialog } from "daymap-react";
import { Device } from '@capacitor/device';
import { useNavigate } from 'react-router-dom';
import { DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { App } from '@capacitor/app';
import Icon from '../../../assets/logo.png'
import ReactMarkdown from 'react-markdown';

export function Announcements() {

    const [platform, setPlatform] = useState<string | null>(null);
    const [version, setVersion] = useState<string | null | undefined>(null);
    const [announcements, setAnnouncements] = useState<ApiQueries.announcements.AnnouncementResponse[]>([]);
    const [rawData, setRawData] = useState<ApiQueries.announcements.AnnouncementResponse[] | undefined>([]);
    const navigate = useNavigate();
    const location = useLocation();
    const [lastDismissedID, setLastDismissID] = useState(-1);
    const [dismissedIds, setDismissedIds] = useState<number[]>([]);
    const { refetch: setRead } = new ApiQueries.announcements.SetRead({ id: Number(lastDismissedID) }).ToQuery();
    const {settings, isPending} = useSettings();
    const { data, refetch } = new ApiQueries.announcements.GetAnnoucements({ 
        appVersion: version || '', 
        deviceType: platform || '' 
    }).ToQuery({ enabled: false });

    useEffect(() => {
        if(isPending) return;
        
        const loadPlatformAndVersion = async () => {
            const deviceInfo = await Device.getInfo();
            if(deviceInfo.platform == "web"){
                const version = settings?.daymapVersion;
                setVersion(version);
            }else{
                const appInfo = await App.getInfo();//Not supported on web
                setVersion(appInfo.version); 
            }
            setPlatform(deviceInfo.platform);
        };
        loadPlatformAndVersion();
    }, [settings]);

    useEffect(() => {
        if (platform && version) {
            refetch();
        }
    }, [platform, version]);

    useEffect(() => {
        if (data) {
            setRawData(data);
        }
    }, [data]);

    useEffect(() => {
        if (rawData != null && rawData.length > 0) {
            const filteredData = rawData.filter(a => dismissedIds.includes(a.ID) == false && (a.DisplayedOnRoute == null || a.DisplayedOnRoute == '' || a.DisplayedOnRoute == location.pathname));
            setAnnouncements(filteredData);
        }
    }, [rawData, location.pathname])

    useEffect(() => {
        async function setAnnouncementRead() {
            if (lastDismissedID != -1)
                await setRead();
        }
        setAnnouncementRead();
    }, [lastDismissedID]);


    const dismiss = async (id: number) => {
        const newDismiss: number[] = dismissedIds;
        newDismiss.push(id)
        setDismissedIds(newDismiss)
        setLastDismissID(id);
        const updated = announcements.slice(1);
        setAnnouncements(updated);
    };

    const ActionButton = (announcement: ApiQueries.announcements.AnnouncementResponse) => {
        if (announcement.ActionURL != '') {
            window.open(announcement.ActionURL);
        } else if (announcement.ActionRoute != '') {
            dismiss(announcement.ID);
            navigate(announcement.ActionRoute);
        }
    }

    return (
        <div>
            <DaymapDialog key={announcements[0]?.ID} open={(announcements != null && announcements.length > 0) ? true : false} onClose={() => dismiss(announcements[0]?.ID)}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2, mx: 'auto' }}>
                    <img src={Icon} style={{ width: '35px', height: '35px', color: 'primary.main' }} />
                    <Typography variant="h6" sx={{ml:1}} >
                        Daymap Announcement
                    </Typography>
                </Box>

                <DialogTitle sx={{ paddingTop: '10px' }}>
                    <Typography align="center" sx={{ paddingTop: '0px', fontSize: '18px'}}>{announcements[0]?.Title}</Typography>
                </DialogTitle>
                <Box>
                    <DialogContent>
                        <Typography sx={{whiteSpace: 'pre-line', fontSize: '14px', '& ul' : {display: 'grid'}, '& p' : {display: 'contents'} }}>
                            <ReactMarkdown>{announcements[0]?.Body}</ReactMarkdown>
                        </Typography>
                    </DialogContent>
                </Box>
                <DialogActions>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pb: 1 }} >
                        {announcements[0]?.ActionLabel != '' && (announcements[0]?.ActionRoute || announcements[0]?.ActionURL) ? <Button sx={{ px: 1, py: 0.5, mr: 2 }} variant="contained" onClick={() => ActionButton(announcements[0])} startIcon={announcements[0].ActionURL ? <DaymapIcon iconType={DaymapIconType.OpenInNew} /> : (announcements[0].ActionRoute ? <DaymapIcon iconType={DaymapIconType.ChevronRight} /> : '')}>{announcements[0]?.ActionLabel}</Button> : ''}
                        <Button sx={{ px: 1, py: 0, ml: 2 }} variant="text" onClick={() => dismiss(announcements[0]?.ID)} startIcon={<DaymapIcon iconType={DaymapIconType.Cross} />}>Close</Button>
                    </Box>
                </DialogActions>

            </DaymapDialog>
        </div>
    );
}
